// internal
import { axios, storage, def, handleError } from './internal';

function MfaVerifySetup(code, onSuccess) {
    axios
        .post('/api/mfa_verify_setup', {
            code,
        })
        .then((res) => {
            storage.transience.setState('internal.success', 'Two-factor authentication has been enabled.');
            onSuccess?.(res.data.data);
        })
        .catch((err) => {
            const { status, data } = err.response || {};
            switch (status) {
                case def.StatusCodes.BAD_REQUEST: // 400
                    switch (data?.code) {
                        case def.ErrorCode.INVALID_PARAM:
                            storage.transience.setState('internal.error', 'Please enter a valid 6-digit code.');
                            break;
                        case def.ErrorCode.MFA_SETUP_REQUIRED:
                            storage.transience.setState(
                                'internal.error',
                                'MFA setup session expired. Please start the setup process again.',
                            );
                            break;
                        default:
                            handleError(err);
                            break;
                    }
                    break;
                case def.StatusCodes.UNAUTHORIZED: // 401
                    switch (data?.code) {
                        case def.ErrorCode.MFA_INVALID_CODE:
                            storage.transience.setState('internal.error', 'Invalid code. Please try again.');
                            break;
                        default:
                            handleError(err);
                            break;
                    }
                    break;
                default:
                    handleError(err);
                    break;
            }
        });
}

export { MfaVerifySetup };
